import type { Observable as ObservableType } from 'rxjs/Observable';
import { mutation$ } from '@atlassian/jira-software-swag';

const MUTATION_NAME = 'BacklogMoveSprint';

type ResultType = {
	success: boolean;
};

export const getMutation = (
	boardId: string,
	sprintId: string,
	targetSprintId: string,
) => `mutation ${MUTATION_NAME} {
        moveSprint (input: {
            boardId: ${boardId},
            sprintId: ${sprintId},
            targetSprintId: ${targetSprintId},
        }) {
            success
        }
    }`;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	baseUrl: string,
	boardId: string,
	sprintId: string,
	targetSprintId: string,
): ObservableType<ResultType> =>
	mutation$<ResultType>(baseUrl, MUTATION_NAME, getMutation(boardId, sprintId, targetSprintId));
